import React from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { Input } from 'almanac-ui/TextInputField/Input'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowRight } from 'blaze-ui/icons'
import { ExampleBrands } from './ExampleBrands/ExampleBrands'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { useBrandKitContext } from './BrandKitContext'
import Styles from './BrandKitForm.module.scss'
import cx from 'classnames'
import { ConnectIntegration } from './ConnectIntegration/ConnectIntegration'

/**
 * Fallback UI shown when we can't analyze the user's website.
 * Allows them to either connect social media, enter a different site, or pick a sample brand.
 */
export const WebsiteFailedBrandKitForm: React.FC<{
  title?: string
  useIntegrations?: boolean
  onSkip?: () => void
}> = ({ title, useIntegrations = false, onSkip }) => {
  const {
    url,
    isValid,
    isBlank,
    inputProps,
    onGenerateFromWebsite,
    onGenerateFromExampleBrand,
    onGenerateFromIntegration,
  } = useBrandKitContext()

  const ordinal = useIntegrations ? 2 : 1

  return (
    <MultiStepStepLayout title={title} onSkip={onSkip}>
      <div className={cx(Styles.container, Styles.integrationFailed)}>
        <Text color="var(--dark-80)">Here are other ways to create your Brand Kit:</Text>
        {useIntegrations && (
          <div className={Styles.section}>
            <Text color="var(--dark-80)">1. Connect your social media account</Text>
            <ConnectIntegration
              platform={null}
              as="button"
              onConnect={(integrations) => {
                if (integrations.length > 0) {
                  const integration = integrations[0]
                  onGenerateFromIntegration({
                    id: integration.id,
                    name: integration.name,
                    provider: integration.provider,
                  })
                }
              }}
            />
          </div>
        )}
        {/* 2. Enter another website */}
        <div className={Styles.section}>
          <Text color="var(--dark-80)">
            {ordinal}. Import a competitor or benchmark company's website to use as a model.
          </Text>
          <div className={Styles.websiteSection}>
            <Input
              {...inputProps}
              value={url}
              errorMessage={undefined}
              placeholder="Enter another website..."
              size="xl"
              className={Styles.websiteField}
            />
            <IconButton
              variant="primary"
              size="xl"
              onPress={onGenerateFromWebsite}
              isDisabled={isBlank || !isValid}
              icon={ArrowRight}
              className={Styles.button}
            />
          </div>
        </div>

        {/* Sample brand templates */}
        <div className={Styles.section}>
          <Text color="var(--dark-80)">{ordinal + 1}. Or start with a sample brand template:</Text>
          <ExampleBrands onExampleBrandSelect={onGenerateFromExampleBrand} />
        </div>
      </div>
    </MultiStepStepLayout>
  )
}
